import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useQueryParams, NumberParam, StringParam } from 'use-query-params';
import { useAuth } from '../../components/Auth';
import ActivitiesPresentational from './ActivitiesPresentational';
import { fetchActivities, upsertActivity, deleteActivity } from '../../lib/fetch/activities';
import { prepareActivity } from '../../lib/helpers/activities';
import { useLoading } from '../../components/Loading';

function Activities(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const [total, setTotal] = useState(0);
  const [t] = useTranslation();
  const [{ token } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading()

  const [query, setQuery] = useQueryParams({
    offset: NumberParam,
    contactId: NumberParam,
    companyId: NumberParam,
    userId: NumberParam,
    type: StringParam,
    done: StringParam,
    priority: StringParam
  });

  const [sortField, setSortField] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');

  const { offset, userId, companyId, contactId, type, done, priority } = query;

  useEffect(() => {
    fetch({ token, offset, userId, companyId, contactId, type, done, priority });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, userId, companyId, contactId, sortField, sortOrder, type, done, priority]);

  const fetch = async (query) => {
    setIsLoading(true);
    const { error, data, headers } = await fetchActivities({ ...query, order: sortField, sort: sortOrder });

    if (error) {
      setIsLoading(false);
      setActivities([]);
      setTotal(0);
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setIsLoading(false);
    setActivities(data);
    setTotal(Number(headers['x-total-count']));
  };

  const onSaveActivity = async ({ id, values, type }) => {
    values = { ...values, user_id: isNaN(values.user_id) ? null : values.user_id }
    const { deal_id, contact_id } = values;
    const data = prepareActivity({ activity: values, type, deal_id, contact_id })
    const { error } = await upsertActivity({ token, id, data });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
    alert.success(t('COMMON:SAVE_SUCCESS'));
    fetch({ token })
  }

  const onDeleteActivity = async (id) => {
    showLoading()
    const { error } = await deleteActivity({ token, id });
    hideLoading()

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
    alert.success(t('COMMON:DELETE_SUCCESS'));
    fetch({ token })
  }

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  return (
    <ActivitiesPresentational
      activities={activities}
      total={total}
      query={query}
      onFilter={setQuery}
      isLoading={isLoading}
      onSaveActivity={onSaveActivity}
      onDeleteActivity={onDeleteActivity}
      onSort={handleSort}
      sortField={sortField}
      sortOrder={sortOrder}
      {...props}
    />
  );
}

export default Activities;
